import React from "react";
import { useCart } from "./CartContext";
import { useNavigate } from "react-router-dom";

function CartDrawer({ open, onClose }) {
  const { items, removeFromCart, updateQuantity, totalItems, totalPrice } = useCart();
  const navigate = useNavigate();

  const handleCheckout = () => {
    onClose();
    navigate("/checkout");
  };

  return (
    <>
      {open && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100"
          style={{ background: "rgba(0,0,0,0.4)", zIndex: 1040 }}
          onClick={onClose}
        />
      )}
      <div
        className="position-fixed top-0 end-0 h-100 bg-white shadow-lg d-flex flex-column"
        style={{
          width: "380px",
          maxWidth: "100vw",
          zIndex: 1050,
          transform: open ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.3s ease",
        }}
      >
        <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
          <h5 className="mb-0 font-weight-bold">
            <i className="material-symbols-rounded me-2">shopping_cart</i>
            Cart ({totalItems})
          </h5>
          <button
            className="btn btn-link p-0 text-dark"
            onClick={onClose}
            aria-label="Close cart"
          >
            <i className="material-symbols-rounded">close</i>
          </button>
        </div>

        <div className="flex-grow-1 overflow-auto p-3">
          {items.length === 0 ? (
            <div className="text-center text-muted mt-5">
              <i className="material-symbols-rounded" style={{ fontSize: "3rem" }}>shopping_bag</i>
              <p className="mt-3">Your cart is empty</p>
            </div>
          ) : (
            items.map((item) => (
              <div key={item.priceId} className="d-flex align-items-center mb-3 pb-3 border-bottom">
                {item.image && (
                  <img
                    src={item.image}
                    alt={item.name}
                    className="border-radius-lg me-3"
                    style={{ width: "64px", height: "64px", objectFit: "cover" }}
                  />
                )}
                <div className="flex-grow-1">
                  <p className="mb-0 text-sm font-weight-bold">{item.name}</p>
                  <p className="mb-1 text-xs text-muted">
                    ${(item.price / 100).toFixed(2)} each
                  </p>
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-sm btn-outline-secondary p-0 px-2"
                      onClick={() => updateQuantity(item.priceId, item.quantity - 1)}
                    >−</button>
                    <span className="text-sm">{item.quantity}</span>
                    <button
                      className="btn btn-sm btn-outline-secondary p-0 px-2"
                      onClick={() => updateQuantity(item.priceId, item.quantity + 1)}
                    >+</button>
                  </div>
                </div>
                <div className="text-end ms-2">
                  <p className="mb-1 text-sm font-weight-bold">
                    ${(item.price * item.quantity / 100).toFixed(2)}
                  </p>
                  <button
                    className="btn btn-link p-0 text-danger text-xs"
                    onClick={() => removeFromCart(item.priceId)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))
          )}
          {items.length > 0 && (
            <div className="mt-2 mb-1">
              <button
                className="btn btn-sm bg-gradient-dark w-100"
                onClick={handleCheckout}
              >
                <i className="material-symbols-rounded me-1" style={{ fontSize: "1rem", verticalAlign: "middle" }}>shopping_cart_checkout</i>
                Checkout
              </button>
            </div>
          )}
        </div>

        {items.length > 0 && (
          <div className="p-3 border-top">
            <div className="d-flex justify-content-between mb-3">
              <span className="font-weight-bold">Total</span>
              <span className="font-weight-bold">${(totalPrice / 100).toFixed(2)}</span>
            </div>
            <button
              className="btn bg-gradient-dark w-100"
              onClick={handleCheckout}
            >
              Proceed to Checkout
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export default CartDrawer;
